"use strict";

window.Suit = window.Suit || {};

Suit.country_list = [{ "name": "Afghanistan", "code": "AF" }, { "name": "land Islands", "code": "AX" }, { "name": "Albania", "code": "AL" }, { "name": "Algeria", "code": "DZ" }, { "name": "American Samoa", "code": "AS" }, { "name": "Andorra", "code": "AD" }, { "name": "Angola", "code": "AO" }, { "name": "Anguilla", "code": "AI" }, { "name": "Antarctica", "code": "AQ" }, { "name": "Antigua and Barbuda", "code": "AG" }, { "name": "Argentina", "code": "AR" }, { "name": "Armenia", "code": "AM" }, { "name": "Aruba", "code": "AW" }, { "name": "Australia", "code": "AU" }, { "name": "Austria", "code": "AT" }, { "name": "Azerbaijan", "code": "AZ" }, { "name": "Bahamas", "code": "BS" }, { "name": "Bahrain", "code": "BH" }, { "name": "Bangladesh", "code": "BD" }, { "name": "Barbados", "code": "BB" }, { "name": "Belarus", "code": "BY" }, { "name": "Belgium", "code": "BE" }, { "name": "Belize", "code": "BZ" }, { "name": "Benin", "code": "BJ" }, { "name": "Bermuda", "code": "BM" }, { "name": "Bhutan", "code": "BT" }, { "name": "Bolivia", "code": "BO" }, { "name": "Bosnia and Herzegovina", "code": "BA" }, { "name": "Botswana", "code": "BW" }, { "name": "Bouvet Island", "code": "BV" }, { "name": "Brazil", "code": "BR" }, { "name": "British Indian Ocean Territory", "code": "IO" }, { "name": "Brunei Darussalam", "code": "BN" }, { "name": "Bulgaria", "code": "BG" }, { "name": "Burkina Faso", "code": "BF" }, { "name": "Burundi", "code": "BI" }, { "name": "Cambodia", "code": "KH" }, { "name": "Cameroon", "code": "CM" }, { "name": "Canada", "code": "CA" }, { "name": "Cape Verde", "code": "CV" }, { "name": "Cayman Islands", "code": "KY" }, { "name": "Central African Republic", "code": "CF" }, { "name": "Chad", "code": "TD" }, { "name": "Chile", "code": "CL" }, { "name": "China", "code": "CN" }, { "name": "Christmas Island", "code": "CX" }, { "name": "Cocos (Keeling) Islands", "code": "CC" }, { "name": "Colombia", "code": "CO" }, { "name": "Comoros", "code": "KM" }, { "name": "Congo", "code": "CG" }, { "name": "Congo, The Democratic Republic of the", "code": "CD" }, { "name": "Cook Islands", "code": "CK" }, { "name": "Costa Rica", "code": "CR" }, { "name": 'Cote D"Ivoire', "code": "CI" }, { "name": "Croatia", "code": "HR" }, { "name": "Cuba", "code": "CU" }, { "name": "Cyprus", "code": "CY" }, { "name": "Czech Republic", "code": "CZ" }, { "name": "Denmark", "code": "DK" }, { "name": "Djibouti", "code": "DJ" }, { "name": "Dominica", "code": "DM" }, { "name": "Dominican Republic", "code": "DO" }, { "name": "Ecuador", "code": "EC" }, { "name": "Egypt", "code": "EG" }, { "name": "El Salvador", "code": "SV" }, { "name": "Equatorial Guinea", "code": "GQ" }, { "name": "Eritrea", "code": "ER" }, { "name": "Estonia", "code": "EE" }, { "name": "Ethiopia", "code": "ET" }, { "name": "Falkland Islands (Malvinas)", "code": "FK" }, { "name": "Faroe Islands", "code": "FO" }, { "name": "Fiji", "code": "FJ" }, { "name": "Finland", "code": "FI" }, { "name": "France", "code": "FR" }, { "name": "French Guiana", "code": "GF" }, { "name": "French Polynesia", "code": "PF" }, { "name": "French Southern Territories", "code": "TF" }, { "name": "Gabon", "code": "GA" }, { "name": "Gambia", "code": "GM" }, { "name": "Georgia", "code": "GE" }, { "name": "Germany", "code": "DE" }, { "name": "Ghana", "code": "GH" }, { "name": "Gibraltar", "code": "GI" }, { "name": "Greece", "code": "GR" }, { "name": "Greenland", "code": "GL" }, { "name": "Grenada", "code": "GD" }, { "name": "Guadeloupe", "code": "GP" }, { "name": "Guam", "code": "GU" }, { "name": "Guatemala", "code": "GT" }, { "name": "Guernsey", "code": "GG" }, { "name": "Guinea", "code": "GN" }, { "name": "Guinea-Bissau", "code": "GW" }, { "name": "Guyana", "code": "GY" }, { "name": "Haiti", "code": "HT" }, { "name": "Heard Island and Mcdonald Islands", "code": "HM" }, { "name": "Holy See (Vatican City State)", "code": "VA" }, { "name": "Honduras", "code": "HN" }, { "name": "Hong Kong", "code": "HK" }, { "name": "Hungary", "code": "HU" }, { "name": "Iceland", "code": "IS" }, { "name": "India", "code": "IN" }, { "name": "Indonesia", "code": "ID" }, { "name": "Iran, Islamic Republic Of", "code": "IR" }, { "name": "Iraq", "code": "IQ" }, { "name": "Ireland", "code": "IE" }, { "name": "Isle of Man", "code": "IM" }, { "name": "Israel", "code": "IL" }, { "name": "Italy", "code": "IT" }, { "name": "Jamaica", "code": "JM" }, { "name": "Japan", "code": "JP" }, { "name": "Jersey", "code": "JE" }, { "name": "Jordan", "code": "JO" }, { "name": "Kazakhstan", "code": "KZ" }, { "name": "Kenya", "code": "KE" }, { "name": "Kiribati", "code": "KI" }, { "name": 'Korea, Democratic People"S Republic of', "code": "KP" }, { "name": "Korea, Republic of", "code": "KR" }, { "name": "Kuwait", "code": "KW" }, { "name": "Kyrgyzstan", "code": "KG" }, { "name": 'Lao People"S Democratic Republic', "code": "LA" }, { "name": "Latvia", "code": "LV" }, { "name": "Lebanon", "code": "LB" }, { "name": "Lesotho", "code": "LS" }, { "name": "Liberia", "code": "LR" }, { "name": "Libyan Arab Jamahiriya", "code": "LY" }, { "name": "Liechtenstein", "code": "LI" }, { "name": "Lithuania", "code": "LT" }, { "name": "Luxembourg", "code": "LU" }, { "name": "Macao", "code": "MO" }, { "name": "Macedonia, The Former Yugoslav Republic of", "code": "MK" }, { "name": "Madagascar", "code": "MG" }, { "name": "Malawi", "code": "MW" }, { "name": "Malaysia", "code": "MY" }, { "name": "Maldives", "code": "MV" }, { "name": "Mali", "code": "ML" }, { "name": "Malta", "code": "MT" }, { "name": "Marshall Islands", "code": "MH" }, { "name": "Martinique", "code": "MQ" }, { "name": "Mauritania", "code": "MR" }, { "name": "Mauritius", "code": "MU" }, { "name": "Mayotte", "code": "YT" }, { "name": "Mexico", "code": "MX" }, { "name": "Micronesia, Federated States of", "code": "FM" }, { "name": "Moldova, Republic of", "code": "MD" }, { "name": "Monaco", "code": "MC" }, { "name": "Mongolia", "code": "MN" }, { "name": "Montenegro", "code": "ME" }, { "name": "Montserrat", "code": "MS" }, { "name": "Morocco", "code": "MA" }, { "name": "Mozambique", "code": "MZ" }, { "name": "Myanmar", "code": "MM" }, { "name": "Namibia", "code": "NA" }, { "name": "Nauru", "code": "NR" }, { "name": "Nepal", "code": "NP" }, { "name": "Netherlands", "code": "NL" }, { "name": "Netherlands Antilles", "code": "AN" }, { "name": "New Caledonia", "code": "NC" }, { "name": "New Zealand", "code": "NZ" }, { "name": "Nicaragua", "code": "NI" }, { "name": "Niger", "code": "NE" }, { "name": "Nigeria", "code": "NG" }, { "name": "Niue", "code": "NU" }, { "name": "Norfolk Island", "code": "NF" }, { "name": "Northern Mariana Islands", "code": "MP" }, { "name": "Norway", "code": "NO" }, { "name": "Oman", "code": "OM" }, { "name": "Pakistan", "code": "PK" }, { "name": "Palau", "code": "PW" }, { "name": "Palestinian Territory, Occupied", "code": "PS" }, { "name": "Panama", "code": "PA" }, { "name": "Papua New Guinea", "code": "PG" }, { "name": "Paraguay", "code": "PY" }, { "name": "Peru", "code": "PE" }, { "name": "Philippines", "code": "PH" }, { "name": "Pitcairn", "code": "PN" }, { "name": "Poland", "code": "PL" }, { "name": "Portugal", "code": "PT" }, { "name": "Puerto Rico", "code": "PR" }, { "name": "Qatar", "code": "QA" }, { "name": "Reunion", "code": "RE" }, { "name": "Romania", "code": "RO" }, { "name": "Russian Federation", "code": "RU" }, { "name": "Rwanda", "code": "RW" }, { "name": "Saint Helena", "code": "SH" }, { "name": "Saint Kitts and Nevis", "code": "KN" }, { "name": "Saint Lucia", "code": "LC" }, { "name": "Saint Pierre and Miquelon", "code": "PM" }, { "name": "Saint Vincent and the Grenadines", "code": "VC" }, { "name": "Samoa", "code": "WS" }, { "name": "San Marino", "code": "SM" }, { "name": "Sao Tome and Principe", "code": "ST" }, { "name": "Saudi Arabia", "code": "SA" }, { "name": "Senegal", "code": "SN" }, { "name": "Serbia", "code": "RS" }, { "name": "Seychelles", "code": "SC" }, { "name": "Sierra Leone", "code": "SL" }, { "name": "Singapore", "code": "SG" }, { "name": "Slovakia", "code": "SK" }, { "name": "Slovenia", "code": "SI" }, { "name": "Solomon Islands", "code": "SB" }, { "name": "Somalia", "code": "SO" }, { "name": "South Africa", "code": "ZA" }, { "name": "South Georgia and the South Sandwich Islands", "code": "GS" }, { "name": "Spain", "code": "ES" }, { "name": "Sri Lanka", "code": "LK" }, { "name": "Sudan", "code": "SD" }, { "name": "Suriname", "code": "SR" }, { "name": "Svalbard and Jan Mayen", "code": "SJ" }, { "name": "Swaziland", "code": "SZ" }, { "name": "Sweden", "code": "SE" }, { "name": "Switzerland", "code": "CH" }, { "name": "Syrian Arab Republic", "code": "SY" }, { "name": "Taiwan, Province of China", "code": "TW" }, { "name": "Tajikistan", "code": "TJ" }, { "name": "Tanzania, United Republic of", "code": "TZ" }, { "name": "Thailand", "code": "TH" }, { "name": "Timor-Leste", "code": "TL" }, { "name": "Togo", "code": "TG" }, { "name": "Tokelau", "code": "TK" }, { "name": "Tonga", "code": "TO" }, { "name": "Trinidad and Tobago", "code": "TT" }, { "name": "Tunisia", "code": "TN" }, { "name": "Turkey", "code": "TR" }, { "name": "Turkmenistan", "code": "TM" }, { "name": "Turks and Caicos Islands", "code": "TC" }, { "name": "Tuvalu", "code": "TV" }, { "name": "Uganda", "code": "UG" }, { "name": "Ukraine", "code": "UA" }, { "name": "United Arab Emirates", "code": "AE" }, { "name": "United Kingdom", "code": "GB" }, { "name": "United States", "code": "US" }, { "name": "United States Minor Outlying Islands", "code": "UM" }, { "name": "Uruguay", "code": "UY" }, { "name": "Uzbekistan", "code": "UZ" }, { "name": "Vanuatu", "code": "VU" }, { "name": "Venezuela", "code": "VE" }, { "name": "Viet Nam", "code": "VN" }, { "name": "Virgin Islands, British", "code": "VG" }, { "name": "Virgin Islands, U.S.", "code": "VI" }, { "name": "Wallis and Futuna", "code": "WF" }, { "name": "Western Sahara", "code": "EH" }, { "name": "Yemen", "code": "YE" }, { "name": "Zambia", "code": "ZM" }, { "name": "Zimbabwe", "code": "ZW" }];

var sizes_range_clothing = Shopify.settings.clothing_size_separator;
var sizes_range_shoe = Shopify.settings.shoe_size_separator;
var sizes_range_accessory = Shopify.settings.accessory_size_separator;

var range_clothing = sizes_range_clothing.split('|');
var range_shoe = sizes_range_shoe.split('|');
var range_accessory = sizes_range_accessory.split('|');

Suit.clothing_size_array_total = [];
Suit.shoe_size_array_total = [];
Suit.accessory_size_array_total = [];

$.each(range_clothing, function (index, value) {
  var limits = value.split(',');
  Suit.clothing_size_array_total.push(limits);
});

$.each(range_shoe, function (index, value) {
  var limits = value.split(',');
  Suit.shoe_size_array_total.push(limits);
});

$.each(range_accessory, function (index, value) {
  var limits = value.split(',');
  Suit.accessory_size_array_total.push(limits);
});

Suit.init = function () {
  Suit.general.init();
  Suit.search.init();
  Suit.redirectFlow.init();
  Suit.minicart.init();
  Suit.cart.init();
  Suit.formAddToCart();
  Suit.mobileVariants();
  Suit.checkMotivatorBar.init();
  Suit.productSlider();
  Suit.wishlist.init();
  Suit.newsletter.init();
  Suit.loginRegister.init();
  Suit.header.init();
  Suit.checkLastViewedProduct.init();
  Suit.addInfoInReturnPage.init();

  if (template === 'page.designer-woman' || template === 'page.designer-man') {
    Suit.designer.init();
  }

  if (template === 'collection' || template === 'search') {
    Suit.collection.init();
  }

  if (template.indexOf('customer') >= 0) {
    Suit.customer.init();
  }

  if (template === 'product') {
    Suit.product.init();
  }

  if (template === 'blog') {
    Suit.blog.init();
  }

  $(document).on('click', '.modal__close', function (e) {
    e.stopPropagation();
    Suit.modal.close($(this).parents('.modal')[0]);
  });

  $(document).on('click', '.modal', function (e) {
    if (e.target === e.currentTarget) {
      Suit.modal.close(this);

      if (!$('.select-variant').hasClass('select-variant--fixed')) {
        $('.overlay').removeClass('visible');
      }
    }
  });

  if ($('.contact-form__submit').length > 0) {
    $('.contact-form__submit').click(function (e) {
      e.preventDefault();
      var termsCheckbox = 'contact-accept-terms';
      $('[for="' + termsCheckbox + '"]').removeClass('error');
      if ($('#' + termsCheckbox) && !$('#' + termsCheckbox).is(':checked')) {
        $('[for="' + termsCheckbox + '"]').addClass('error');
        return false;
      }
      $(this).parents('form').submit();
    });
  }
};

// modal behaviour
Suit.modal = {
  open: function open(selector) {
    var modal = $(selector);
    var showOverlay = modal.data('modal-overlay');
    var delay = modal.data('modal-delay') || 0;

    modal.removeData('modal-overlay-hide-disabled');
    if ($('.overlay').hasClass('visible') && showOverlay) {
      modal.data('modal-overlay-hide-disabled', '');
    }

    setTimeout(function () {
      modal.addClass('modal--visible');

      if (showOverlay) {
        modal.insertAfter('.overlay');
        $('body').toggleClass('modal-visible');
        $('.overlay').addClass('visible');
      }
    }, delay * 1000);

    $('.modal').trigger('modal-open', { modal: modal });
  },

  openFast: function open(selector) {
    var modal = $(selector);
    var showOverlay = modal.data('modal-overlay');
    var delay = modal.data('modal-delay') || 0;

    modal.removeData('modal-overlay-hide-disabled');
    if ($('.overlay').hasClass('visible') && showOverlay) {
      modal.data('modal-overlay-hide-disabled', '');
    }

    setTimeout(function () {
      modal.addClass('modal--visible');

      if (showOverlay) {
        modal.insertAfter('.overlay');
        $('body').toggleClass('modal-visible');
        $('.overlay').addClass('visible');
      }
    }, 0);

    $('.modal').trigger('modal-open', { modal: modal });
  },

  close: function close(selector) {
    var modal = $(selector);
    var showOverlay = modal.data('modal-overlay');
    var overlayDisabled = modal.data('modal-overlay-hide-disabled') !== undefined;
    modal.removeClass('modal--visible');
    $('body').toggleClass('modal-visible');

    if (!overlayDisabled && showOverlay) {
      $('.overlay').removeClass('visible');
    }

    $('.modal').trigger('modal-close', { modal: modal });
  }
};

Suit.header = function () {
  function init() {
    initHeader();
  }

  function initHeader() {
    /** open menu mobile */
    $('.menu-xs-btn').on('click', function (e) {
      e.stopPropagation();
      $(".st-container").addClass("menu-xs-open");
      // scrollLock.disablePageScroll($('.menu-xs__1l')[0]);
    });

    // Check if it is iOS
    var isiOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;

    if (isiOS === true) {
      $('.st-container').css('cursor', 'pointer').css('-webkit-tap-highlight-color', 'rgba(0, 0, 0, 0)');
    }

    $(document).on('click', '.menu-xs-open', function (event) {
      event.stopPropagation();
      var $target = $(event.target);

      if ($target.parents().hasClass('menu-xs__close') || !$target.parents().hasClass('search_container') && !$target.hasClass('search_container') || !$target.parents().hasClass('menu-xs') && !$target.hasClass('menu-xs')) {
        $(".st-container").removeClass("menu-xs-open");
        scrollLock.enablePageScroll($('.menu-xs__1l')[0]);
      }
    });

    //On click open submenus
    $(".menu-xs li").click(function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      //   scrollLock.disablePageScroll($('.menu-xs__1l')[0]);

      if ($(this).hasClass("menu-xs__2l-item--has-submenu")) {
        // ha un terzo livello

        e.preventDefault();
        $(this).toggleClass("menu-xs__2l-item--active");
        $(this).siblings().toggle();
        $(this).find(".menu-xs__3l").toggleClass("menu-xs__3l--active");
      } else if ($(this).hasClass("menu-xs__1l-item--has-submenu")) {
        // ha un secondo livello

        e.preventDefault();
        $(this).toggleClass("menu-xs__1l-item--active");
        $(this).find(".menu-xs__2l").toggleClass("menu-xs__2l--active");
        $(this).siblings().toggle();
      }
    });

    var previousHover = false;
    //On hover show submenu on desktop
    $(".menu__1l-item").hoverIntent({
      timeout: 160,
      interval: 60,
      over: function over() {
        var currentHover = $(this);

        if (previousHover) {
          previousHover.find('.menu__1l-link--active').removeClass('menu__1l-link--active');
          previousHover.find('.menu__megamenu--active').removeClass('menu__megamenu--active');
        }
        previousHover = currentHover;

        if ($(this).hasClass("menu__item--has-submenu")) {
          $(this).find(".menu__1l-link").addClass("menu__1l-link--active");
          $(this).find(".menu__megamenu").addClass("menu__megamenu--active");
        }
      },
      out: function out() {
        if (!$('.header .menu').is(':hover')) {
          $('.menu__1l-item .menu__1l-link--active').removeClass('menu__1l-link--active');
          $('.menu__1l-item .menu__megamenu--active').removeClass('menu__megamenu--active');
        }
      }
    });

    /* LOGO HIDE ON SCROLL DOWN AND HEADER FIXED */

    var lastScrollTop = 0;

    $(".st-content").scroll(function () {
      var st = $(this).scrollTop();
      var sticky = $(".header");
      var content = $(".main-content");
      var menu = $(".menu");

      if ($(window).width() > 1024) {
        if (st > lastScrollTop && !$(".header").hasClass("header--fixed")) {
          if (content.offset().top <= -$(".header").outerHeight()) {
            $(".logo__link").fadeOut("slow");
            $(".logo").css("height", "0");
            sticky.addClass("header--fixed");
            menu.css("margin-bottom", "30px");
          }
        } else {
          //if (content.offset().top >= -112){
          if (st < lastScrollTop) {
            sticky.removeClass("header--fixed");
            menu.css("margin-bottom", "20px");
            $(".logo").removeAttr("style");
            $(".logo__link").fadeIn("slow");
          }

          if (template === 'collection' || template === 'search') {
            Suit.collection.recalcFilterSidebar();
          }
        }

        lastScrollTop = st;
      };
    });
  }

  return {
    init: init
  };
}();

Suit.general = function () {
  function init() {
    initGeneral();
  }

  function initGeneral() {
    $(document).on("click", ".warning-modal .close, .overlay", function () {
      $(".overlay").removeClass('visible');
      $(".warning-modal").remove();
    });
  }

  return {
    init: init
  };
}();

Suit.search = function () {
  var currentAjaxRequest = null;
  var shopURL = $('body').data('shop-url');
  var searchPath = shopURL + '/search?type=product&q=';

  function init() {
    initEvents();
    initAutocomplete();
  }

  function initEvents() {
    $('#search-terms').focus();
    $('body').on('click', '.search-link', function (e) {
      e.preventDefault();
      $('.search_container').addClass('active');
      $('#search-terms').focus();
      $('#search-terms').trigger('touchstart');
      scrollLock.disablePageScroll($('.search_container')[0]);
      setTimeout(function () {
        $('#search-terms').focus();
      }, 500);
    });

    $('.search_form .search-close').on('click', function (e) {
      e.stopPropagation();
      $('.search_container').removeClass('active');
      scrollLock.enablePageScroll($('.search_container')[0]);
      scrollLock.enablePageScroll($('.search__results-wrapper')[0]);
      scrollLock.enablePageScroll($('.menu-xs__1l')[0]);
      $('input.search-terms').val('').trigger('keyup');
    });

    $(document).mouseup(function (e) {
      var container = $(".search_container");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.search_form .search-close').trigger('click');
      }
    });

    if (Suit.isMobile(1024)) {
      $('body').on('click', '.search_container', function (e) {
        e.stopPropagation();
        $('.st-container').removeClass('menu-xs-open');
        $(this).addClass('active');
        scrollLock.disablePageScroll($('.search_container')[0]);
        scrollLock.disablePageScroll($('.search__results-wrapper')[0]);
      });
    }

    $(".search_form, .search__form, .header_search_form").on("submit", function (e) {
      var formValue = $(this).find('input[name="q"]').val();
      var cleanFormValue = encodeURI(formValue);

      e.preventDefault();

      if (cleanFormValue == null) {
        window.location.href = '/search';
      } else {
        window.location.href = searchPath + cleanFormValue;
      }
    });
  }

  function initAutocomplete() {
    $('form.search_form, form.search, form.header_search_form').each(function () {
      var input = $(this).find('input[name="q"]');

      // Adding a list for showing search results.
      $('<div class="search__results-wrapper"><div class="search__results"><div class="search__results__container products"><ul class="search__results__products"></ul></div></div></div>').appendTo($(this));

      // Listening to keyup and change on the text field within these search forms.
      input.attr('autocomplete', 'off').bind('keyup', function (e) {
        if (input.val() == '') {
          $('.search__results__container').hide();
          $('.search__results__products').empty();
          $('.search__results__collections').empty();
        }

        var term = $(this).val();

        var cleanTerm = encodeURI(term);
        var form = $(this).closest('form');
        var searchURL = searchPath + cleanTerm;

        form.find('.search__results__container').hide();
        var resultsListProducts = form.find('.search__results__products');
        var resultsListCollections = form.find('.search__results__collections');

        if (term.length >= 3) {
          if (currentAjaxRequest != null) currentAjaxRequest.abort();

          currentAjaxRequest = $.getJSON(searchURL + '*&view=json', function (data) {
            resultsListProducts.empty();
            resultsListCollections.empty();

            // If we have no results.
            if (data.results_count == 0) {
              var no_results_string = Shopify.trans.generalSearchNo_results;
              $('.search__results').append('<div class="search__results__container no-results"><span>' + no_results_string + '</span></div>');
              resultsListProducts.hide();
            } else {
              // If we have results.
              $.each(data.results, function (index, item) {
                if (index >= 9) {
                  return false;
                }

                var link = $('<a></a>').attr('href', item.url);

                //Collect collection handles if product
                if (item.object_type == 'product') {

                  var collectionHandles = [];
                  for (var i = 0; i < item.collections.length; i++) {
                    collectionHandles.push(item.collections[i].handle);
                  }

                  if (item.unsellable == false) {
                    if (item.available == true) {
                      if (item.raw_compare > item.raw_price) {
                        var itemPrice = '<span class="was_price">' + item.compare + '</span>' + '<span class="current_price">' + item.price + '</span> ';
                      } else {
                        if (item.price_varies && item.price_min > 0) {
                          var itemPrice = Shopify.trans.productsGeneralFrom + ' ' + item.price;
                        } else if (item.price > 0 || item.raw_price > 0) {
                          var itemPrice = item.price;
                        }
                      }
                    } else {
                      var itemPrice = Shopify.trans.productsProductSold_out;
                    }
                  }

                  if (item.thumbnail != 'NULL') {
                    link.append('<div class="image"><img class="lazyload transition--fade-in" src="' + item.thumbnail + '" /></div>');
                  }
                  var output = '<div class="info"><div class="title"><p class="name">' + item.title + '</p><p class="vendor">' + item.vendor + '</p></div>';
                  if (item.unsellable == false) {
                    output += '<div class="item-pricing">' + itemPrice + '</div>';
                  }
                  output += '</div></div>';
                  link.append(output);
                }

                link.wrap('<li class="item-result result--' + item.object_type + '"></li>');
                resultsListProducts.append(link.parent());

                $('.search__results__container.products').show();
                resultsListProducts.show();
              });

              // The Ajax request will return at the most 5 results.
              // If there are more than 5, let's link to the search results page.
              if (data.results_count >= 9) {
                resultsListProducts.append('<li class="all-results"><span class="see-all"><a href="' + searchURL + '*">' + Shopify.trans.generalSearchAll_results + ' (' + data.results_count + ')</a></span></li>');
              }
            }

            $('.search__results-wrapper').show();
          });
        }
      });
    });
  }

  return {
    init: init
  };
}();

Suit.isAdmin = function () {
  var isCustomizing = false;
  var url = window.location.hostname;
  if (window.location !== window.parent.location) {
    isCustomizing = true;
  }
  return isCustomizing;
};

Suit.redirectFlow = function () {
  function init() {
    if (!Suit.isAdmin() && Suit.settings.redirect.is_enable) {
      initRedirectFlow();
    }
  }

  function initRedirectFlow() {
    var all_country = [];

    var config = {
      selector: '.country-switcher__select',
      value_text: '.country-switcher__value'
    };

    if (Suit.settings.redirect.store1_countries) {
      var store1_countries = Suit.settings.redirect.store1_countries.replace(/\s/g, '').split(',');

      for (var i = 0; i < store1_countries.length; i++) {
        all_country.push({ 'store': '1', 'code': store1_countries[i], 'url': Suit.settings.redirect.default_url[0] });
      }
    }

    if (Suit.settings.redirect.store2_countries) {
      var store2_countries = Suit.settings.redirect.store2_countries.replace(/\s/g, '').split(',');

      for (var i = 0; i < store2_countries.length; i++) {
        all_country.push({ 'store': '2', 'code': store2_countries[i], 'url': Suit.settings.redirect.default_url[1] });
      }
    }

    if (Suit.settings.redirect.store3_countries) {
      var store3_countries = Suit.settings.redirect.store3_countries.replace(/\s/g, '').split(',');

      for (var i = 0; i < store3_countries.length; i++) {
        all_country.push({ 'store': '3', 'code': store3_countries[i], 'url': Suit.settings.redirect.default_url[2] });
      }
    }

    if (Suit.settings.redirect.store4_countries) {
      var store4_countries = Suit.settings.redirect.store4_countries.replace(/\s/g, '').split(',');

      for (var i = 0; i < store4_countries.length; i++) {
        all_country.push({ 'store': '4', 'code': store4_countries[i], 'url': Suit.settings.redirect.default_url[3] });
      }
    }

    for (var i = 0; i < Suit.country_list.length; i++) {
      var _country = all_country.filter(function (country) {
        return country.code == Suit.country_list[i].code;
      });
      if (_country[0]) {
        $('<option/>').attr('data-href', _country[0].url).attr('data-name', Suit.country_list[i].name).attr('data-iso', Suit.country_list[i].code).val(Suit.country_list[i].code).html(Suit.country_list[i].name).appendTo(config.selector);
      }
    }

    function getUrlVars() {
      var vars = [],
          hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }

    var current_store_url = $('body').data('shop-url');

    if (getUrlVars()['redirect'] == 'true') {
      Cookies.set('countryRedirectSuit', current_store_url, { expires: 60 });

      if (getUrlVars()['shippingCountry']) {
        Cookies.set('countrySuit', getUrlVars()['shippingCountry'], { expires: 60 });
      }
    }

    if (Cookies.get('countrySuit') && Cookies.get('countryRedirectSuit')) {
      var url = Cookies.get('countryRedirectSuit');

      if (url && url == current_store_url) {
        // Do nothing
      } else if (url && url != current_store_url) {
        Suit.redirectFlow.metaRedirect(all_country, Cookies.get('countrySuit'));
      }

      $(config.selector).val($(config.selector).find('option[data-iso="' + Cookies.get('countrySuit') + '"]').val());
      $(config.value_text).text(Cookies.get('countrySuit'));
    } else {
      $.ajax({
        url: 'https://freegeoip.live/json/',
        type: 'POST',
        dataType: 'jsonp',
        //timeout: 2000,
        maxTries: 2,
        retryCodes: [404, 500, 520],
        success: function success(location, textStatus, jqXHR) {
          var _country = Suit.country_list.filter(function (country) {
            return country.code == location.country_code;
          });
          Cookies.set('realCountrySuit', location.country_code);

          if (getUrlVars()['shippingCountry']) {
            Cookies.set('countrySuit', getUrlVars()['shippingCountry'], { expires: 60 });
            Cookies.set('countryRedirectSuit', current_store_url, { expires: 60 });
          } else if (Cookies.get('countrySuit') == null || Cookies.get('countrySuit') != location.country_code) {
            Cookies.set('countrySuit', location.country_code, { expires: 60 });
          }

          var country = all_country.filter(function (country) {
            return country.code == location.country_code;
          });

          var url = Cookies.get('countryRedirectSuit') || country[0].url;

          $(config.selector).val($(config.selector).find('option[data-iso="' + location.country_code + '"]').val());
          $(config.value_text).text(Cookies.get('countrySuit'));

          if (url && url == current_store_url) {
            // Do nothing
          } else if (url && url != current_store_url) {
            Suit.redirectFlow.metaRedirect(all_country, Cookies.get('countrySuit'));
          } else if (country[0].url == current_store_url) {
            Cookies.set('countryRedirectSuit', current_store_url, { expires: 60 });
          }
        }
      });
    }

    $(config.selector).on('change', function (e) {
      e.preventDefault();
      var code = $(this).find('option:selected').data('iso');
      var country = all_country.filter(function (country) {
        return country.code == code;
      });
      Cookies.set('countrySuit', country[0].code, { expires: 60 });
      Cookies.set('countryRedirectSuit', country[0].url, { expires: 60 });
      $(config.value_text).text(country[0].code);
      Suit.redirectFlow.metaRedirect(all_country, code);
    });
  }

  function metaRedirect(all_country, code) {
    if (code == 'uk') {
      code = 'gb';
    }

    try {
      var country = all_country.filter(function (country) {
        return country.code == code.toUpperCase();
      });
      var url_splitted = country[0].url.replace('https://', '').split('.');
      /* GET NEXT INSTANCE */
      var next_instance = false;
      switch (url_splitted[0]) {
        case 'it':
        case 'eu':
        case 'uk':
        case 'row':
          next_instance = url_splitted[0];
          break;
        default:
          break;
      }

      /* GET NEW URL */
      var new_url = country[0].url;
      if (redirect_metafields && next_instance) {
        switch (redirect_scope) {
          case 'product':
            new_url += '/products/';
            new_url += redirect_metafields[next_instance];
            break;
          case 'collection':
            new_url += '/collections/';
            for (var _index = 0; _index < redirect_metafields.length; _index++) {
              if (typeof redirect_metafields[_index][next_instance] != "undefined") {
                new_url += redirect_metafields[_index][next_instance];
              }
            }
            break;
          case 'page':
            new_url += '/pages/';
            for (var index = 0; index < redirect_metafields.length; index++) {
              if (typeof redirect_metafields[index][next_instance] != "undefined") {
                new_url += redirect_metafields[index][next_instance];
              }
            }
            break;
          case 'blog':
            new_url += '/blogs/';
            for (var index = 0; index < redirect_metafields.length; index++) {
              if (typeof redirect_metafields[index][next_instance] != "undefined") {
                new_url += redirect_metafields[index][next_instance];
              }
            }
            break;
          case 'article':
            new_url += '/blogs/';
            for (var index = 0; index < redirect_metafields.length; index++) {
              if (typeof redirect_metafields[index][next_instance] != "undefined") {
                new_url += redirect_metafields[index][next_instance];
              }
            }
            break;
          default:
            break;
        }
      }
      new_url += '?redirect=true&shippingCountry=';
      new_url += country[0].code;

      /* REDIRECT */
      window.location.replace(new_url);
    } catch (err) {
      console.log("Catch message:" + err.message);
    }
  }

  return {
    init: init,
    metaRedirect: metaRedirect
  };
}();

Suit.isMobile = function (width) {
  var isMobile = false;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(window).width() <= width) {
    isMobile = true;
  }

  return isMobile;
};

Suit.minicart = function () {
  var settings = {
    openMinicartSelector: '.menu-utility__item--cart, .minicart',
    minicartSelector: '.minicart',
    minicartContent: '.minicart__content',
    minicartItemRemove: '.minicart__item-remove',
    minicartTotals: '.minicart__totals',
    minicartTotal: '.minicart__totals .total',
    minicartClose: '.minicart__close',
    minicartCounter: '.minicart__count',
    moneyFormat: $('body').data('money-format'),
    triggeredOpenMinicart: false
  };

  function init() {
    initMinicart();
  }

  function initMinicart() {
    _buildMinicart();

    if (!Suit.isMobile(1024)) {
      $(settings.openMinicartSelector).hoverIntent({
        timeout: 160,
        interval: 60,
        over: function over() {
          $(settings.minicartContent).scrollTop(0);
          $(settings.minicartSelector).addClass('visible');
        },
        out: function out() {
          if (!$(settings.minicartSelector).is(':hover')) {
            $(settings.minicartContent).scrollTop(0);
            $(settings.minicartSelector).removeClass('visible');
          }
        }
      });

      $('body').on('click', settings.minicartItemRemove, function () {
        var line = $(this).closest('.minicart__item').data('line');
        _removeItem(line);
      });
    } else {
      $('body').on('click', settings.minicartClose, function () {
        closeMinicart();
      });
    }
  }

  function openMinicart() {
    refreshMinicart();
    $(settings.minicartContent).scrollTop(0);

    if (Suit.isMobile(1024)) {
      $(settings.minicartSelector).insertAfter('.overlay');
      $('.overlay').addClass('visible');
    }

    settings.triggeredOpenMinicart = true;
    $(settings.minicartSelector).addClass('visible');

    var timeoutMinicart = setTimeout(function () {
      settings.triggeredOpenMinicart = false;
      closeMinicart();
    }, 5000);

    //Blocco il timeout se l'utente sta utilizzando il minicart
    $(document).on('touchstart mouseover', '.minicart__content', function () {
      clearTimeout(timeoutMinicart);
    });

    settings.triggeredOpenMinicart = false;
  }

  function closeMinicart() {
    $(settings.minicartSelector).removeClass('visible');

    if (Suit.isMobile(1024)) {
      $('.overlay').removeClass('visible');
    }
  }

  function _buildMinicart(cb=null) {
    var items = [];

    $.getJSON(window.Shopify.routes.root + 'cart.js', function (cart, textStatus) {
      $(settings.minicartContent).empty();

      // Show empty cart
      if (cart.item_count === 0) {
        $(settings.minicartSelector).addClass('empty');
        $(settings.minicartContent).append('<p class="minicart__empty-message">' + Shopify.trans.cartGeneralContinue_browsing_html + '</p>');
        $(settings.minicartCounter).text('0');
        return;
      }

      $(settings.minicartSelector).removeClass('empty');

      var itemsInCart = [];
      itemsInCart = cart.items;

      // Add each item to minicart
      $.each(itemsInCart, function (index, cartItem) {

        var prodImg = '';
        if (cartItem.image != null) {
          prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_250x$1").replace('http:', '');
        } else {
          prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function (key, value) {
            if (key.charAt(0) === '_' || !value) {
              delete cartItem.properties[key];
            }
          });
        }

        if (cartItem.line_level_discount_allocations.length !== 0) {
          for (var discount in cartItem.line_level_discount_allocations) {
            var amount = cartItem.line_level_discount_allocations[discount].amount;
            cartItem.line_level_discount_allocations[discount].formattedAmount = Shopify.formatMoney(amount, settings.moneyFormat);
          }
        }

        if (cart.cart_level_discount_applications.length !== 0) {
          for (var discount in cart.cart_level_discount_applications) {
            var amount = cart.cart_level_discount_applications[discount].total_allocated_amount;
            cart.cart_level_discount_applications[discount].formattedAmount = Shopify.formatMoney(amount, settings.moneyFormat);
          }
        }

        // Create item's data object and add to 'items' array
        var item = {
          key: cartItem.key,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title ? cartItem.variant_title : null,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity ? cartItem.quantity : null,
          price: cartItem.price ? Shopify.formatMoney(cartItem.price, settings.moneyFormat) : null,
          vendor: cartItem.vendor,
          linePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
          originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
          discounts: cartItem.line_level_discount_allocations,
          discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true,
          variants: cartItem.variants || null
        };

        items.push(item);
        _writeMinicartItem(item);
      });

      _writeMinicartTotal(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
      $(settings.minicartCounter).text(cart.item_count);

      if(cb){
        cb();
      }
    });
  }

  function _writeMinicartItem(item) {
    // price markup
    var price_html = '';
    if (item.discountsApplied) {
      price_html = "\n        <span class=\"price\">" + item.linePrice + "\n          <span class=\"was_price\">" + item.originalLinePrice + "</span>\n        </span>\n      ";
    } else {
      price_html = item.originalLinePrice;
    }

    var remove_html = "\n      <div class=\"minicart__item-remove\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8.485 8.485\">\n          <defs>\n            <clipPath id=\"a\">\n              <rect class=\"a\" width=\"8.485\" height=\"8.485\"/>\n            </clipPath>\n          </defs>\n          <g class=\"b\">\n            <rect width=\"11\" height=\"1\" transform=\"translate(7.778 8.485) rotate(-135)\"/>\n            <rect width=\"11\" height=\"1\" transform=\"translate(0 7.778) rotate(-45)\"/>\n          </g>\n        </svg>\n      </div>\n    ";

    // b2b table markup
    var table_html = '';
    if (item.variants) {
      var table_rows = '';
      item.variants.forEach(function (variant) {
        table_rows += "\n          <tr class=\"b2b-row\" data-line=\"" + variant.line + "\">\n            <td>" + variant.variation + "</td>\n            <td class=\"align-center\">" + variant.itemQty + "</td>\n            <td class=\"cart-item__table-price align-right\">" + variant.price + "</td>\n            <td class=\"align-center\">" + remove_html + "</td>\n          </tr>\n      ";
      });

      table_html = "\n        <table class=\"cart-item__table\">\n          <thead>\n            <tr>\n              <th>" + Shopify.trans.generalSize + "</th>\n              <th class=\"align-center\">" + Shopify.trans.productsProductQuantityShort + "</th>\n              <th class=\"cart-item__table-price align-right\">" + Shopify.trans.cartGeneralPrice + "</th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>" + table_rows + "</tbody>\n        </table>\n      ";
    }

    var item_html = "\n      <div class=\"minicart__item\" data-line=\"" + item.line + "\">\n        <div class=\"minicart__item-image\">\n          <a class=\"ratio-container\" href=\"" + item.url + "\">\n            <img class=\"transition--fade-in lazyload\" src=\"" + item.img + "\"/>\n          </a>\n        </div>\n        <div class=\"minicart__item-info\">\n          <div class=\"minicart__item-name\">" + item.name + "</div>\n          <div class=\"minicart__item-vendor\">" + item.vendor + "</div>\n          <div class=\"minicart__item-size\">" + Shopify.trans.generalSize + ": " + item.variation + "</div>\n          <div class=\"minicart__item-qty\">" + Shopify.trans.productsProductQuantityShort + ": " + item.itemQty + "</div>\n          <div class=\"minicart__item-price\">" + price_html + "</div>\n        </div>\n        " + remove_html + "\n      </div>\n    ";

    $(settings.minicartContent).append(item_html);
  }

  function _writeMinicartTotal(total_html) {
    $(settings.minicartTotal).text(total_html);
  }

  function _removeItem(line) {
    setTimeout(function () {
      Shopify.changeItem(line, 0, refreshMinicart);
    }, 250);
  }

  function refreshMinicart(cb=null) {
    setTimeout(function () {
      _buildMinicart(cb);
    }, 150);
  };

  return {
    init: init,
    openMinicart: openMinicart,
    refreshMinicart: refreshMinicart,
    closeMinicart: closeMinicart
  };
}();

//Funzione che aggiorna le select nascoste in base ai link testuali delle varianti
Suit.selectVariant = function (link, selectToChange) {

  //Seleziono la variante
  link.addClass("select-variant__link--selected");

  //Aggiorno il form nascosto
  var optionValue = link.attr("data-value");

  //selectToChange = $('.select-variant__hidden');

  selectToChange.find('option').each(function () {
    link.removeAttr('selected');
  });

  selectToChange.val(optionValue).trigger('change');
  selectToChange.find("option[value=" + optionValue + "]").attr('selected', true).trigger('change');
};

Suit.mobileVariants = function () {
  // Su mobile se clicco sulla label delle taglie apre il panello delle taglie
  $(document).on('click', '.select-variant__title', function () {
    var variants = $(".select-variant .select-variant__links");
    if (variants.children().length >= 8) {
      variants.addClass('owl-carousel owl-theme').owlCarousel({
        items: 8,
        loop: false,
        center: true,
        nav: true,
        dots: false
      });
    }
    $(".overlay").addClass("visible");
    $(".select-variant").addClass("select-variant--fixed");
  });

  // Su mobile se clicco su "close" chiudo il panello delle taglie
  $(document).on('click', '.select-variant__close, .overlay', function () {
    $(".overlay").removeClass("visible");
    Suit.minicart.closeMinicart();
    $(".select-variant").removeClass("select-variant--fixed");
    $(".select-variant .select-variant__links").trigger('destroy.owl.carousel').removeClass('owl-carousel owl-theme');
    return false;
  });
};

Suit.formAddToCart = function () {
  function totalProductsQty() {
    var qty = 0;
    $('.select-variant__qty').each(function (i, el) {
      qty += el.value;
    });
    return qty;
  }

  function showAddToCart(show) {
    if (show) {
      $(".js-select-variant").hide();
      $(".js-add-to-cart").show();
    } else {
      $(".js-select-variant").show();
      $(".js-add-to-cart").hide();
    }
  }

  $(document).on('keyup', '.select-variant__qty', function () {
    var total = totalProductsQty();

    if (total > 0) {
      showAddToCart(true);
    } else {
      showAddToCart(false);
    }
  });

  $(document).on('click', '.js-change-quantity', function () {
    var total = totalProductsQty();

    var isGiftCard = $("body").find('.select-variant__giftquantity').length > 0;

    if (!isGiftCard) {
      if (total > 0) {
        showAddToCart(true);
      } else {
        showAddToCart(false);
      }
    }
  });

  // Se clicco su una variante
  $(document).on('click', '.select-variant__link', function () {
    $(".select-variant .select-variant__links").trigger('destroy.owl.carousel').removeClass('owl-carousel owl-theme');

    //Se non è sold-out e se non è già selezionata
    if (!$(this).hasClass("select-variant__link--sold-out") && !$(this).hasClass("select-variant__link--selected")) {

      Suit.selectVariant($(this), $('.select-variant__hidden'));
      $(this).siblings().removeClass("select-variant__link--selected");

      if ($(window).width() >= 1024) {

        //Mostro l'add to cart
        showAddToCart(true);

        Suit.modal.close('.modal--back-in-stock');
        $('.purchase-details__buttons').show();
      } else {
        // < 1024

        $(".select-variant").removeClass("select-variant--fixed");
        $(".overlay").removeClass("visible");
        $(".select-variant__title span").html($(this).html());
        showAddToCart(true);
      }
    } else if ($(this).hasClass("select-variant__link--sold-out")) {

      $(".overlay").removeClass("visible");
      Suit.modal.open('.modal--back-in-stock');

      $(".select-variant").removeClass("select-variant--fixed");
    }
  });
};

Suit.addInfoInReturnPage = function () {
  function init() {
    addTextUnderReturnForm();
  }

  function addTextUnderReturnForm() {
    var detect_return_page = $('#returnDiv');

    if (detect_return_page.length) {

      var checkExist = setInterval(function () {
        var returnForm = $('#returnFormFooter');
        if (returnForm.length) {

          var detect_language = $('.country-switcher__value').text();

          if (detect_language === 'ITIT') {

            var span = $('<div />').css("margin-top", "20px").html('Consulta la nostra <a href="../pages/resi-e-rimborsi">politica di reso</a>.');
            $(span).insertAfter(returnForm);
          } else {
            var span = $('<div />').css("margin-top", "20px").html('Find out more about our <a href="../pages/return-request">return policy</a>.');
            $(span).insertAfter(returnForm);
          }
          clearInterval(checkExist);
        }
      }, 100);
    }
  }
  return {
    init: init

  };
}();

Suit.checkLastViewedProduct = function () {
  function init() {
    if (template === 'collection' || template === 'search') {
      checkLastViewedProduct();
    } else if (template === 'product') {
      // Do nothing
    } else {
      Cookies.remove('lastProduct', { path: '' });
    }
  }

  function checkLastViewedProduct() {
    //Se clicco su un prodotto in collection, mi salvo la position
    $(document).on('click', 'body.collection .product-card, body.search .product-card', function () {
      Cookies.set('lastProduct', $(this).data('product-handle'), { expires: 60 });
    });

    if (Cookies.get('lastProduct')) {
      var retry = 3;

      var timeout = setInterval(function () {
        var product = $('.product-card[data-product-handle="' + Cookies.get('lastProduct') + '"]');
        if (product.length) {
          clearInterval(timeout);
          $('.st-content').animate({
            scrollTop: product.position().top - $('header').outerHeight()
          }, 500);
          Cookies.remove('lastProduct');
        }

        retry -= 1;
        if (retry == 0) {
          clearInterval(timeout);
        }
      }, 400);
    }
  }

  return {
    init: init,
    checkLastViewedProduct: checkLastViewedProduct
  };
}();

Suit.cart = function () {
  function init() {
    initCart();
  }

  function initCart() {
    _initializeQuantityBox();
    _checkRequiredInputs();
    _requireInvoice();
    _checkQtyOnXmag();
  }

  function _initializeQuantityBox() {
    $('body').on('click', '.js-change-quantity', function () {
      var $this = $(this),
          input = $(this).siblings('input'),
          val = parseInt(input.val()),
          valMax = 100000000000000000000000000000,
          valMin = input.attr('min') || 0;

      if (input.attr('max') != null) {
        valMax = input.attr('max');
      }

      if (isNaN(val) || val < valMin) {
        input.val(valMin);
        return false;
      } else if (val > valMax) {
        input.val(valMax);
        return false;
      }

      if ($this.data('func') == 'plus') {
        if (val < valMax) input.val(val + 1);
      } else {
        if (val > valMin) input.val(val - 1);
      }
      input.trigger('change');
    });
  }

  function _requireInvoice() {
    $('#require_invoice').change(function () {
      if (this.checked) {
        $('.cart-page__invoice-input').addClass('active');
      } else {
        $('.cart-page__invoice-input').removeClass('active');
      }
    });
  }

  function _checkRequiredInputs() {
    $('#cart_form .add_to_cart').click(function () {
      var canSubmit = true;

      $('.cart-page__tos .checkbox').removeClass('error');
      $('.cart-page__invoice .checkbox').removeClass('error');
      $('.invoice-error').remove();

      if ($('#require_invoice').is(':checked')) {
        if (Shopify.settings.show_cart_vat_id && Shopify.settings.cart_vat_id_required) {
          if ($('#vatId').val().replace(/^\s+|\s+$/g, "").length == 0) {
            $('#vatId').parent().append('<div class="invoice-error error">' + Shopify.trans.cartFieldRequired + '</div>');
            canSubmit = false;
          }
        }

        if (Shopify.settings.show_cart_pec_sdi) {
          if ($('#vatId').val()) {
            if ($('#vatId').val().replace(/^\s+|\s+$/g, "").length == 0) {
              $('#vatId').parent().append('<div class="invoice-error error">' + Shopify.trans.cartFieldRequired + '</div>');
              canSubmit = false;
            }

            if (!$('#pec').val() && !$('#sdi').val()) {
              $('.cart-page__pec-sdi').append('<div class="invoice-error error">' + Shopify.trans.cartPecSdiError + '</div>');
              canSubmit = false;
            }
          }
        }

        if (Shopify.settings.show_cart_fiscal_code) {
          if (!$('#fiscalCode').val()) {
            $('.cart-page__invoice .checkbox').addClass('error');
            $('#fiscalCode').parent().append('<div class="invoice-error error">' + Shopify.trans.cartFieldRequired + '</div>');
            canSubmit = false;
          }
        }
      }

      if (!$('#cart_form input[name="policy"]').is(':checked')) {
        $('.cart-page__tos .checkbox').addClass('error');
        canSubmit = false;
      }

      if (canSubmit == true) {
        if ($('#require_invoice').is(':checked')) {
          $('#cart_form').append('<input type="hidden" class="request_invoice_tag" name="attributes[requireInvoice]" value="true"/>');
        } else {
          $('#cart_form').append('<input type="hidden" class="request_invoice_tag" name="attributes[requireInvoice]" value=""/>');
        }

        $(this).submit();
      }

      return canSubmit;
    });
  }

  function _checkQtyOnXmag() {
    if ($('#cart_form').length > 0) {
      //Suit check qty
      var variant_array = [];
      var products_not_available = [];

      $('.cart-item').each(function () {
        var item_barcode = $(this).data('variant-barcode');
        if (item_barcode != "1001861100016" && item_barcode != "1001861100022" && item_barcode != "1001861100033") {
          variant_array.push({
            'barcode': item_barcode,
            'qty_requested': parseInt($('[data-variant-barcode="' + $(this).data('variant-barcode') + '"] .cart-item__qty input[type="number"]').val())
          });
        }
      });

      $.ajax({
        url: 'https://middleware.suitnegozi.com/cs_m/checkQty',
        type: 'post',
        dataType: 'json',
        data: {
          variant_array: variant_array
        },
        success: function success(data) {
          var data = JSON.parse(data.data);
          var count = 0;
          var total = Object.keys(data).length;

          $.each(data, function (j, result) {
            if (result.response == true) {
              count++;
            } else {
              products_not_available.push(result.barcode);
            }
          });

          if (total != count) {
            // Cambiando il type al bottone, non faccio il submit, ma controllo sempre l'evento click
            $('#checkout').attr('type', 'button');
          }
        }
      });
    }

    $('button#checkout').on('click', function (e) {
      var length = products_not_available.length;

      if (length > 0) {
        var warning_text = '';

        $.each(products_not_available, function (index, barcode) {
          var title = $("[data-variant-barcode=" + barcode + " ]").find('.cart-item__name').text();
          var brand = $("[data-variant-barcode=" + barcode + " ]").find('.cart-item__brand').text();
          var size = $("[data-variant-barcode=" + barcode + " ]").find('.cart-item__sizes .size').text();

          warning_text += Shopify.trans.warningQtyFirst + " " + title + " " + brand + " " + size + " " + Shopify.trans.warningQtyLast;
          if (!(index === length - 1)) {
            warning_text += '</br></br>';
          }
        });

        var warning = " <h2> " + Shopify.trans.warning + " </h2> <div class='warning'>" + warning_text + "</div>";
        var warning = '<div class="warning-modal fadeIn"><a href="javascript:void(0)" class="close"> <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8.485" height="8.485" viewBox="0 0 8.485 8.485"><defs><clipPath id="a"><rect class="a" width="8.485" height="8.485"/></clipPath></defs><g class="b"><rect width="11" height="1" transform="translate(7.778 8.485) rotate(-135)"/><rect width="11" height="1" transform="translate(0 7.778) rotate(-45)"/></g></svg> </a>' + warning + '</div>';
        $("body").append("<div class='warning-modal'>" + warning + "</div>");
        $(".overlay").addClass('visible');

        return false;
      }

      return true;
    });
  }

  return {
    init: init
  };
}();

Suit.designer = function () {
  function init() {
    initDesigner();
  }

  function initDesigner() {
    $(".all-brands .all-brands__section").each(function () {
      var id = $(this).attr('id');
      if ($(this).find('ul').children().length == 0) {
        $(this).closest('.all-brands__section').remove();
        $('a[href="#' + id + '"]').closest('.all-brands__letter').remove();
      }
    });

    $(".all-brands .all-brands__vendors-list").each(function () {
      var item = $(this).find("li");
      if (item.length >= 2) {
        item.addClass("column-style");
      }
    });

    $(".all-brands .specific-letter").each(function () {
      $(this).click(function () {
        if ($(".specific-letter").hasClass("active")) {
          $(".specific-letter").removeClass("active");
        }
        $(this).addClass("active");
      });
    });

    $(".all-brands").css("display", "block");

    $(document).on('click', '.all-brands__letter a', function (e) {
      e.preventDefault();
      var anchor = $(this).attr("href");
      document.querySelector(anchor).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    });
  }

  return {
    init: init
  };
}();

Suit.productSlider = function () {
  $('.products-slider').each(function () {
    if ($(this).hasClass('home-carousel')) {
      if (!$(this).hasClass('owl-loaded') && $(this).children().length >= 5) {
        $(this).owlCarousel({
          center: true,
          items: 1,
          loop: true,
          margin: 20,
          dots: false,
          stagePadding: 100,
          autoplay: true,
          autoplayTimeout: 3000,
          responsive: {
            1024: {
              items: 5,
              margin: 40,
              stagePadding: 0
            }
          }
        });
      } else if ($(this).children().length < 5 && $(this).children().length > 1) {
        $(this).owlCarousel({
          items: 1,
          margin: 20,
          dots: false,
          stagePadding: 100,
          autoplay: true,
          autoplayTimeout: 3000,
          responsive: {
            1024: {
              items: 5,
              margin: 40,
              stagePadding: 0
            }
          }
        });
      }
    } else {
      if (!$(this).hasClass('owl-loaded') && $(this).children().length >= 5) {
        $(this).owlCarousel({
          loop: true,
          margin: 10,
          nav: false,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          responsive: {
            0: {
              items: 2
            },
            480: {
              items: 3
            },
            1024: {
              items: 3
            },
            1200: {
              items: 5
            },
            1920: {
              items: 5
            }
          }
        });
      } else if ($(this).children().length < 5 && $(this).children().length >= 1) {
        $(this).owlCarousel({
          margin: 10,
          nav: false,
          autoplay: true,
          autoplayTimeout: 3000,
          responsive: {
            0: {
              items: 2,
              loop: false
            },
            480: {
              items: 3,
              loop: false
            },
            1024: {
              items: 3
            },
            1200: {
              items: 5
            },
            1920: {
              items: 5
            }
          }
        });
      } else if (!$(this).hasClass('owl-loaded')) {
        $(this).closest('.featured-products').hide();
      }
    }
  });

  $(document).on('shopify:section:select', reloadOwlCarousel);

  function reloadOwlCarousel(e) {
    Suit.productSlider();
  }
};

Suit.product = function () {
  function init() {
    initProduct();

    var productImages = $(".gallery__image");
    var firstImage = $(".gallery__image")[0];
    var isGiftCard = $("body").find('.product-page--suit-gift-card').length > 0;

    if (!Suit.isMobile(1024)) {
      $(firstImage).imagesLoaded(function () {
        initProductGallery(productImages);
      });
    } else {
      initProductGallery(productImages);
    }

    sortSize('.select-variant__link', '.select-variant__links', $('.product-page'));

    $('.product-card').each(function () {
      Suit.product.sortSize('.product-card__size', '.product-card__sizes', $(this));
    });
    //change image on variant click gift card
    if (isGiftCard) {
      selectVariantGiftCard();
    }
  }

  function selectVariantGiftCard() {
    var owl = $('.owl-carousel');
    var imageIndex = null;
    $(document).on("click", ".select-variant__links a", function (e) {
      owl.owlCarousel();
      imageIndex = e.target.getAttribute("data-index");
      owl.trigger("to.owl.carousel", imageIndex);
    });
  }

  function initProduct() {
    //Open modal shipping
    $(document).on("click", ".shipping-link", function () {
      Suit.modal.open('.modal--shipping');
    });

    //Open modal size
    $(document).on("click", ".size-link", function () {
      Suit.modal.open('.modal--size');
    });

    // Notify me ajax
    $(document).on('submit', '.notify_form form', function (e) {
      e.preventDefault();
      $(this).find('label.checkbox').removeClass('error');
      if ($(this).find('#notify_privacy').is(':checked')) {
        var f = this;(window._bisq = window._bisq || []).push(function () {
          new BIS.MobiliaForm(f);
        });
        return true;
      }
      $(this).find('label.checkbox').addClass('error');
      return false;
    });

    $('.btn-select-size').on('click', function () {
      if ($('.select-variant__link--selected').length == 0) {
        var message = Shopify.trans.productsProductWarning;
        var description = Shopify.trans.productsProductSelectSize;
        Shopify.onError({ message: message, description: description });
      }
    });
  }

  function initProductGallery(productImages) {
    if (productImages.length > 0) {
      var setCounterStart = function setCounterStart(num) {
        $(".counter__start").html(num < 10 ? '0' + num : num);
      };

      // counter management
      var counterEnd = productImages.length < 10 ? '0' + productImages.length : productImages.length;

      $(".counter__end").html(counterEnd);

      if (!Suit.isMobile(1024)) {
        $('.gallery__wrapper').owlCarousel({
          items: 1,
          center: true,
          dots: false,
          nav: true,
          navText: ['<svg class="caret prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path d="M14.79 268.33c-4.21 4.59-5.73 10.32-4.21 15.29 1.15 4.21 116.22 108.19 255 231.29 188.86 167.06 255.38 224.03 262.26 224.03 7.27 0 58.88-49.32 233.59-222.5C884.53 394.1 986.99 290.12 988.9 285.53c4.58-10.7-5.73-24.47-18.35-24.47-4.97 0-47.02 38.61-122.72 113.54-63.09 62.7-161.34 160.19-218.3 216.77L525.92 693.83 281.63 477.44C121.45 335.61 34.66 261.06 29.31 261.06c-4.2 0-11.08 3.44-14.52 7.27z"/></svg>', '<svg class="caret next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path d="M14.79 268.33c-4.21 4.59-5.73 10.32-4.21 15.29 1.15 4.21 116.22 108.19 255 231.29 188.86 167.06 255.38 224.03 262.26 224.03 7.27 0 58.88-49.32 233.59-222.5C884.53 394.1 986.99 290.12 988.9 285.53c4.58-10.7-5.73-24.47-18.35-24.47-4.97 0-47.02 38.61-122.72 113.54-63.09 62.7-161.34 160.19-218.3 216.77L525.92 693.83 281.63 477.44C121.45 335.61 34.66 261.06 29.31 261.06c-4.2 0-11.08 3.44-14.52 7.27z"/></svg>']
        }).on('changed.owl.carousel', function (e) {
          setCounterStart(e.item.index + 1);
        });
      } else {
        $('.gallery__wrapper').owlCarousel({
          items: 1,
          center: true,
          dots: false,
          nav: true
        }).on('changed.owl.carousel', function (e) {
          setCounterStart(e.item.index + 1);
        });
      }
    }
  }

  function sortSize(item, wrapper, product) {
    var is_numeric = true;

    var main_collection = product.data('type');

    // Controllo tutte le taglie per verificare che non siano valori numerici ma con scale taglie ad-hoc come 00 o 0
    product.find(item).each(function () {
      if (!$.isNumeric($(this).data('size')) && $(this).data('size') != '0' && $(this).data('size') != '00') {
        is_numeric = false;
      }
    });

    // Se tutte le taglie sono di tipo numerico, posso ordinarle numericamente
    if (is_numeric) {
      product.find(item).sort(function (a, b) {
        var size_a = parseInt($(a).attr('data-size'));
        var size_b = parseInt($(b).attr('data-size'));
        return size_a < size_b ? -1 : size_a > size_b ? 1 : 0;
      }).appendTo(product.find(wrapper));
    }

    // Altrimenti analizzo la tipologia del prodotto, prendo la prima taglia e la ricerco nelle scale taglie inserite nel customize
    else {
        var first_variant = product.find(item).first().data('size') + '';
        var order_array = false;

        if (main_collection == 'abbigliamento' || main_collection == 'clothing') {
          Suit.clothing_size_array_total.forEach(function (clothing_size_array) {
            if (clothing_size_array.indexOf(first_variant) > -1) {
              order_array = clothing_size_array;
            }
          });
        } else if (main_collection == 'scarpe' || main_collection == 'shoes') {
          Suit.shoe_size_array_total.forEach(function (shoe_size_array) {
            if (shoe_size_array.indexOf(first_variant) > -1) {
              order_array = shoe_size_array;
            }
          });
        } else {
          Suit.accessory_size_array_total.forEach(function (accessory_size_array) {
            if (accessory_size_array.indexOf(first_variant) > -1) {
              order_array = accessory_size_array;
            }
          });
        }

        if (order_array) {
          // Ordino le varianti a seconda della scala taglia selezionata
          product.find(item).sort(function (a, b) {
            var size_a = $(a).data('size') + '';
            var size_b = $(b).data('size') + '';
            return order_array.indexOf(size_a) - order_array.indexOf(size_b);
          }).appendTo(product.find(wrapper));
        }
      }

    product.find(wrapper).addClass('sorted');
  }

  return {
    init: init,
    sortSize: sortSize
  };
}();

Suit.customer = {
  init: function init() {
    $(document).on('click', '.toggle-new-address', function () {
      $('.address_tables--container').toggle();
      Shopify.CustomerAddress.toggleNewForm();
      $('#action-new-address').toggle();
    });

    $('.customer_address .checkbox-trigger label').on('click', function () {
      $(this).parent().find('input').trigger('click');
    });

    $('ul.account-tabs').not('.disabled').each(function () {
      var active,
          content,
          links = $(this).find('a');
      active = links.first().parent().addClass('active');
      content = $(active.find('a').attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });

      $(this).find('a').parent().click(function (e) {
        e.preventDefault();
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).find('a').attr('href'));
        active.addClass('active');
        content.show();

        if (history.pushState) {
          history.pushState(null, null, $(this).attr('href'));
        } else {
          location.hash = $(this).attr('href');
        }

        return false;
      });
    });

    $('.account-links').attr('style', '');

    if (window.location.hash && window.location.pathname === "/account") {
      $('.account-tabs li a').each(function () {
        if ($(this).attr('href') === window.location.hash) {
          $(this).trigger('click');
        }
      });
    }
  }
};

Suit.collection = function () {
  function init() {
    initCollection();
    initSortBy();
    initFilterEvents();

    $('.product-card').each(function () {
      Suit.product.sortSize('.product-card__size', '.product-card__sizes', $(this));
    });

    if (!Suit.isMobile(1200)) {
      initFilterSidebar();
    }
  }

  function initCollection() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    if (!Suit.isMobile(1200)) {
      $(document).on('click', '.filtering', function (e) {
        if (!$('.st-container').hasClass('filters-open')) {
          $(this).find('.count_or_icon').text(' - ');
          $('.st-container').addClass('filters-open');
        } else {
          $(this).find('.count_or_icon').text(' + ');
          $('.st-container').removeClass('filters-open');
        }

        recalcFilterSidebar();
      });
    }

    var count = 0;

    if (!Suit.isMobile(1200)) {
      $('.shop-filters__container').each(function () {
        var ps = new PerfectScrollbar($(this)[0], { handlers: ['keyboard', 'wheel', 'touch'], wheelPropagation: true });
        count++;
      });

      /* ALE ACHILLI: nuovo scroll tramite frecce su e giu */
      $(document).on('click', '.shop-filters__title', function () {
        /* rimuovo frecce quando clicco sull'elemento */
        $('#prevNavPerfectScroll').remove();
        $('#nextNavPerfectScroll').remove();

        if ($(this).attr('data-click-state') == 1) {
          $(this).attr('data-click-state', 0);

          /* rimuovo frecce quando clicco sull'elemento per la seconda volta e questo si chiude */
          $('#prevNavPerfectScroll').remove();
          $('#nextNavPerfectScroll').remove();
        } else {
          $(this).attr('data-click-state', 1);

          var checkExist = setInterval(function () {
            /* verifico se lo scroll sia attivo */
            if ($('.shop-filters__filter.active').length) {
              /* rimuovo le vecchie frecce per generarle nuove */
              $('#prevNavPerfectScroll').remove();
              $('#nextNavPerfectScroll').remove();

              /* inietto frecce per lo scroll */
              $("<p id='prevNavPerfectScroll' style='margin: 0; height: 10px; text-align: right; padding: 5px 16px; cursor:pointer;'><svg xmlns='http://www.w3.org/2000/svg' width='8' height='4.438' viewBox='0 0 8 4.438'><path id='Union_23' data-name='Union 23' d='M2.212,2.4-1.351,5.962l-.387-.388,3.949-3.95.1.1h0l.94.94L6.262,5.675l-.387.388Z' transform='translate(1.738 -1.625)' fill='#000000'/></svg></p>").insertAfter('.shop-filters__filter.active  .shop-filters__title');
              $("<p id='nextNavPerfectScroll' style='text-align: right; padding: 2px 15px; height: 0; cursor:pointer;'  ><svg xmlns='http://www.w3.org/2000/svg' width='8' style='transform: rotate(180deg);'; height='4.438' viewBox='0 0 8 4.438'><path id='Union_23' data-name='Union 23' d='M2.212,2.4-1.351,5.962l-.387-.388,3.949-3.95.1.1h0l.94.94L6.262,5.675l-.387.388Z' transform='translate(1.738 -1.625)' fill='#000000'/></svg></p>").insertAfter('.shop-filters__filter.active .shop-filters__container');
              /* fine iniezione frecce per lo scroll */

              /* modifica design, cambio colore scroll */
              $('.ps__thumb-y').css('background', 'black');

              /* settaggio scroll nei bottoni, contenitore e n pixel to scroll */
              var container_elements_scroll = document.querySelector(".shop-filters__filter.active .shop-filters__container");
              /* tot pixel da scrollare */
              var scrollAmount = 18;
              /* fine settaggio parametri scroll */

              $('#prevNavPerfectScroll').click(function () {
                var currentHeight = container_elements_scroll.scrollTop;
                var scroll_prev = currentHeight - scrollAmount;
                container_elements_scroll.scrollTop = scroll_prev;
              });

              $('#nextNavPerfectScroll').click(function () {
                var currentHeight = container_elements_scroll.scrollTop;
                var scroll_next = currentHeight + scrollAmount;
                container_elements_scroll.scrollTop = scroll_next;
              });

              clearInterval(checkExist);
            } else {
              /* finito tutto rimuovo le frecce dalla pagina per tornare ai controlli iniziali. */
              $('#prevNavPerfectScroll').remove();
              $('#nextNavPerfectScroll').remove();
            }
          }, 100); // check every 100ms
        }
      });

      /* fine nuovo scroll tramite frecce su e giu */

      var checkExist = setInterval(function () {
        if ($('.ps').length == count) {
          $('.ps').scrollTop(1);
          if ($('.ps.ps--active-y').length > 0) {
            $('.ps').scrollTop(0);
            clearInterval(checkExist);
          }
        }
      }, 100); // check every 100ms
    }

    //Se c'è solo un brand, non faccio vedere il filtro brand
    if ($('.shop-filters__filter.filter-brand .shop-filters__content').children().length <= 1) {
      $('.shop-filters__filter.filter-brand').hide();
    }

    $('.shop-filters__filter').each(function () {
      if ($(this).find('.shop-filters__content').children().length < 1) {
        $(this).addClass('empty');
      }
    });

    function sortByKeyAsc(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }

    //Gestione separazione filtri scarpe e abbigliamento
    var sizes_range_clothing = Suit.settings.clothing_size_separator;
    var sizes_range_shoe = Suit.settings.shoe_size_separator;
    var sizes_range_accessory = Suit.settings.accessory_size_separator;
    var clothing_size_array_total = [];
    var clothing_size_grouped = {};
    var shoe_size_array_total = [];
    var shoe_size_grouped = {};
    var accessory_size_array_total = [];
    var accessory_size_grouped = {};

    var range_clothing = sizes_range_clothing.split('|');
    var range_shoe = sizes_range_shoe.split('|');
    var range_accessory = sizes_range_accessory.split('|');

    $.each(range_clothing, function (index, value) {
      var limits = value.split(',');
      clothing_size_array_total.push(limits);
    });

    $.each(range_shoe, function (index, value) {
      var limits = value.split(',');
      shoe_size_array_total.push(limits);
    });

    $.each(range_accessory, function (index, value) {
      var limits = value.split(',');
      accessory_size_array_total.push(limits);
    });

    var all_clothing_sizes = [];
    var all_shoe_sizes = [];
    var all_accessory_sizes = [];

    $('.filter-size').each(function () {
      var filters = $(this).find('.shop-filters__link');
      var array_shoe = [];
      var array_clothing = [];
      var array_accessory = [];
      var type = $(this).data('type').replace(/\s/g, '');
      var current_div = $(this);

      filters.each(function () {
        var temp = [];

        if (type == 'shoe') {
          //var number = parseFloat($(this).text().replace(/[^\d\.]/g, ''));
          temp['content'] = $(this);
          temp['size'] = $(this).text().replace(/\s/g, '');
          array_shoe.push(temp);
          sortByKeyAsc(array_shoe, 'size');
          all_shoe_sizes.push(temp);
        } else if (type == 'clothing') {
          temp['content'] = $(this);
          temp['size'] = $(this).text().replace(/\s/g, '');
          array_clothing.push(temp);
          all_clothing_sizes.push(temp);
        } else if (type == 'accessory') {
          temp['content'] = $(this);
          temp['size'] = $(this).text().replace(/\s/g, '');
          array_accessory.push(temp);
          all_accessory_sizes.push(temp);
        }
      });

      if (type == 'clothing') {
        clothing_size_array_total.forEach(function (clothing_size_array, x) {
          clothing_size_grouped[x] = [];
          clothing_size_array.forEach(function (y) {
            var found = false;
            array_clothing.filter(function (item) {
              if (!found && item['size'] == y) {
                clothing_size_grouped[x].push(item);
                found = true;
                return false;
              } else return true;
            });
          });
        });
      } else if (type == 'shoe') {
        shoe_size_array_total.forEach(function (shoe_size_array, x) {
          shoe_size_grouped[x] = [];
          shoe_size_array.forEach(function (y) {
            var found = false;
            array_shoe.filter(function (item) {
              if (!found && item['size'] == y) {
                shoe_size_grouped[x].push(item);
                found = true;
                return false;
              } else return true;
            });
          });
        });
      } else if (type == 'accessory') {
        accessory_size_array_total.forEach(function (accessory_size_array, x) {
          accessory_size_grouped[x] = [];
          accessory_size_array.forEach(function (y) {
            var found = false;
            array_accessory.filter(function (item) {
              if (!found && item['size'] == y) {
                accessory_size_grouped[x].push(item);
                found = true;
                return false;
              } else return true;
            });
          });
        });
      }
    });

    //Gestione separazione clothing size
    var clothing_filter_div = $('.shop-filters').find('.filter-size[data-type="clothing"] .shop-filters__content'); //Prendo il div che contiene la lista di filtri taglia abbigliamento
    clothing_filter_div.empty(); //Tolgo i precedenti filtri
    var not_mapped = [];

    //Trovo le taglie non mappate
    $.each(all_clothing_sizes, function (index, item) {
      var found = false;
      $.each(clothing_size_grouped, function (index, clothing_size_array) {
        $.each(clothing_size_array, function (index, array) {
          if (item.size == array.size) {
            found = true;
          }
        });
      });

      if (!found) {
        not_mapped.push(item);
      }
    });

    // Conteggio il numero di schiere
    var total_group = 0;
    var count = 0;
    $.each(clothing_size_grouped, function (index, clothing_size_array) {
      if (!$.isEmptyObject(clothing_size_array)) {
        total_group++;
      }
    });

    //Stampo tutte le taglie raggruppate e stampo il sepatore alla fine di ognuna
    $.each(clothing_size_grouped, function (index, clothing_size_array) {
      for (var i = 0; i < clothing_size_array.length; i++) {
        clothing_filter_div.append(clothing_size_array[i].content[0]);
        $(clothing_size_array[i].content[0]).wrap('<li></li>');
      }

      //Controllo che ci siano dei valori in frontend per quella schiera di taglie
      if (clothing_size_array.length > 0 && (!(total_group == count + 1) || not_mapped.length > 0)) {
        //clothing_filter_div.append('<li class="separator"></li>');
        count++;
      }
    });

    //Se ci sono taglie non mappate, le stampo alla fine
    if (not_mapped.length > 0) {
      for (var i = 0; i < not_mapped.length; i++) {
        clothing_filter_div.append(not_mapped[i].content[0]);
        $(not_mapped[i].content[0]).wrap('<li></li>');
      }
    }

    //Gestione separazione shoe size
    var shoe_filter_div = $('.shop-filters').find('.filter-size[data-type="shoe"] .shop-filters__content'); //Prendo il div che contiene la lista di filtri taglia scarpe
    shoe_filter_div.empty(); //Tolgo i precedenti filtri
    not_mapped = [];

    //Trovo le taglie non mappate
    $.each(all_shoe_sizes, function (index, item) {
      var found = false;
      $.each(shoe_size_grouped, function (index, shoe_size_array) {
        $.each(shoe_size_array, function (index, array) {
          if (item.size == array.size) {
            found = true;
          }
        });
      });

      if (!found) {
        not_mapped.push(item);
      }
    });

    // Conteggio il numero di schiere
    var total_group = 0;
    var count = 0;
    $.each(shoe_size_grouped, function (index, shoe_size_array) {
      if (!$.isEmptyObject(shoe_size_array)) {
        total_group++;
      }
    });

    //Stampo tutte le taglie raggruppate e stampo il sepatore alla fine di ognuna
    $.each(shoe_size_grouped, function (index, shoe_size_array) {
      for (var i = 0; i < shoe_size_array.length; i++) {
        shoe_filter_div.append(shoe_size_array[i].content[0]);
        $(shoe_size_array[i].content[0]).wrap('<li></li>');
      }

      //Controllo che ci siano dei valori in frontend per quella schiera di taglie
      if (shoe_size_array.length > 0 && (!(total_group == count + 1) || not_mapped.length > 0)) {
        //shoe_filter_div.append('<li class="separator"></li>');
      }
    });

    //Se ci sono taglie non mappate, le stampo alla fine
    if (not_mapped.length > 0) {
      for (var i = 0; i < not_mapped.length; i++) {
        shoe_filter_div.append(not_mapped[i].content[0]);
        $(not_mapped[i].content[0]).wrap('<li></li>');
      }
    }

    //Gestione separazione accessory size
    var accessory_filter_div = $('.shop-filters').find('.filter-size[data-type="accessory"] .shop-filters__content'); //Prendo il div che contiene la lista di filtri taglia accessori
    accessory_filter_div.empty(); //Tolgo i precedenti filtri
    not_mapped = [];

    //Trovo le taglie non mappate
    $.each(all_accessory_sizes, function (index, item) {
      var found = false;
      $.each(accessory_size_grouped, function (index, accessory_size_array) {
        $.each(accessory_size_array, function (index, array) {
          if (item.size == array.size) {
            found = true;
          }
        });
      });

      if (!found) {
        not_mapped.push(item);
      }
    });

    // Conteggio il numero di schiere
    var total_group = 0;
    var count = 0;
    $.each(accessory_size_grouped, function (index, accessory_size_array) {
      if (!$.isEmptyObject(accessory_size_array)) {
        total_group++;
      }
    });

    //Stampo tutte le taglie raggruppate e stampo il sepatore alla fine di ognuna
    $.each(accessory_size_grouped, function (index, accessory_size_array) {
      for (var i = 0; i < accessory_size_array.length; i++) {
        accessory_filter_div.append(accessory_size_array[i].content[0]);
        $(accessory_size_array[i].content[0]).wrap('<li></li>');
      }

      //Controllo che ci siano dei valori in frontend per quella schiera di taglie
      if (accessory_size_array.length > 0 && (!(total_group == count + 1) || not_mapped.length > 0)) {
        //accessory_filter_div.append('<li class="separator"></li>');
      }
    });

    //Se ci sono taglie non mappate, le stampo alla fine
    if (not_mapped.length > 0) {
      for (var i = 0; i < not_mapped.length; i++) {
        accessory_filter_div.append(not_mapped[i].content[0]);
        $(not_mapped[i].content[0]).wrap('<li></li>');
      }
    }

    //Ordino i filtri prezzo
    var sort_price = {};
    $('.filter-price').each(function () {
      var filters = $(this).find('.shop-filters__link');
      var current_div = $(this);
      filters.each(function () {
        var filter_value = $(this).data('filter');

        if (filter_value.indexOf("more-than") >= 0 || filter_value.indexOf("piu-di") >= 0) {
          sort_price['999'] = $(this);
        } else if (filter_value.indexOf("less-than") >= 0 || filter_value.indexOf("meno-di") >= 0) {
          sort_price['0'] = $(this);
        } else {
          var low_limit = filter_value.split('-')[0].toString();
          sort_price[low_limit] = $(this);
        }
      });

      var price_filter_div = current_div.find('.shop-filters__content');
      price_filter_div.empty();

      $.each(sort_price, function (index, item) {
        price_filter_div.append(item);
        $(item).wrap('<li></li>');
      });
    });
  }

  function initFilterSidebar() {
    $(".st-content").scroll(function () {
      recalcFilterSidebar();
    });

    $(window).resize(function () {
      recalcFilterSidebar();
    });
  }

  function initSortBy() {
    if (Suit.isMobile(1200)) {
      $('.sorting .custom-dropdown__current').on('click', function () {
        $('body').css('overflow', 'hidden');
        $('.custom-dropdown__container').toggleClass('visible');
        //scrollLock.disablePageScroll($('.custom-dropdown__container')[0]); console.log("DISABILITO");
      });

      $('.custom-dropdown.collection__sort-by a.custom-dropdown__current').on('click', function () {
        $('.custom-dropdown.collection__sort-by').addClass('active');
      });

      $(document).on('click', function (e) {
        //if(e.target == document.querySelector('.custom-dropdown__link li a')){
        if (e.target.matches('.custom-dropdown__link li a, .custom-dropdown__link li')) {
          e.preventDefault();
          e.stopPropagation();

          $('body').css('overflow', 'auto');
          $('.custom-dropdown__container').removeClass('visible');
          scrollLock.enablePageScroll($('.custom-dropdown__container')[0]);//console.log("RIABILITO");
        }
        //if (e.target == document.querySelector('.custom-dropdown__buttons')) {
        if (e.target.matches('.custom-dropdown__buttons')) {
          e.preventDefault();
          e.stopPropagation();

          $('body').css('overflow', 'auto');
          $('.custom-dropdown__container').removeClass('visible');
          scrollLock.enablePageScroll($('.custom-dropdown__container')[0]);//console.log("RIABILITO");
        }
      });

      $(document).on('click', '.collection__sort-by .close a', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('body').css('overflow', 'auto');
        $('.custom-dropdown__container').removeClass('visible');
        scrollLock.enablePageScroll($('.custom-dropdown__container')[0]);//console.log("RIABILITO");
      });
    }

    if (Shopify.queryParams.sort_by) {
      $(".sorting .custom-dropdown__link li:not(.close) a").removeClass('active');
      $(".sorting .custom-dropdown__link li:not(.close) a[data-value=" + Shopify.queryParams.sort_by + "]").addClass('active');
    }

    $('.sorting .custom-dropdown__link li:not(.close) a').on('click', function () {
      var value = $(this).data('value');
      $(".sorting .custom-dropdown__select option[value=" + value + "]").prop('selected', true).trigger('change');
      $('.sorting .custom-dropdown__link a').removeClass('active');
      $(this).addClass('active');
    });
  }

  function initFilterEvents() {
    $(document).on('click', '.filter-bar .filtering, .shop-filters__close', function (e, triggered) {
      if (!triggered && ($('.shop-filters__filter.active').length == 0 || $(window).width() >= 1200)) {
        $('.shop-filters').toggleClass('active');
      }

      if ($(window).width() <= 1200) {
        $(this).closest('.shop-filters').find('.shop-filters__filter').removeClass('active').css('display', 'flex');
        $(this).closest('.shop-filters').find('.shop-filters__show-all').css('visibility', 'visible');

        if ($(this).hasClass('shop-filters__close')) {
          $('.shop-filters').removeClass('active');
        }

        //Fix per safari scroll
        if (!$('.shop-filters').hasClass('active') && $(this).hasClass('shop-filters__close')) {
          scrollLock.enablePageScroll($('.shop-filters')[0]);

          $('#current-filters-mobile').each(function () {
            scrollLock.enablePageScroll($(this)[0]);
          });

          $('.shop-filters__wrap').each(function () {
            scrollLock.enablePageScroll($(this)[0]);
          });

          $('.shop-filters__content').each(function () {
            scrollLock.enablePageScroll($(this)[0]);
          });
        } else if ($('.shop-filters').hasClass('active') && $(this).hasClass('filtering')) {
          scrollLock.disablePageScroll($('.shop-filters')[0]);

          $('#current-filters-mobile').each(function () {
            scrollLock.disablePageScroll($(this)[0]);
          });

          $('.shop-filters__wrap').each(function () {
            scrollLock.disablePageScroll($(this)[0]);
          });

          $('.shop-filters__content').each(function () {
            scrollLock.disablePageScroll($(this)[0]);
          });
        }
      }
    });

    $('.shop-filters__filter .shop-filters__title').on('click', function () {
      if (!Suit.isMobile(1200)) {
        $('.shop-filters__filter').not($(this).parent()).each(function () {
          $(this).removeClass('active');
          $(this).find('.shop-filters__more-less').text('+');
        });

        if (!$(this).parent().hasClass('active')) {
          $(this).parent().addClass('active');
          $(this).find('.shop-filters__more-less').text('-');
        } else {
          $(this).parent().removeClass('active');
          $(this).find('.shop-filters__more-less').text('+');
        }
        recalcFilterSidebar();
      } else {
        if (!$(this).parent().hasClass('active')) {
          $(this).parent().addClass('active');

          $(this).closest('.shop-filters').find('.shop-filters__filter:not(.active)').hide();
          $(this).closest('.shop-filters').find('.shop-filters__show-all').css('visibility', 'hidden');
        } else {
          $(this).closest('.shop-filters').find('.shop-filters__filter').removeClass('active').css('display', 'flex');
        }
      }
    });

    $('.filter-explode__title[data-filter]').on('click', function (e) {
      e.stopPropagation();
      var filter_type = $(this).data('filter');
      $('.shop-filters').addClass('active');
      $('.shop-filters__filter[data-filter = "' + filter_type + '"] .shop-filters__title').trigger('click');
    });
  }

  function recalcFilterSidebar() {
    $('.collection__container').css('min-height', $('.shop-filters').height());
    if ($(".st-content").scrollTop() >= $('.collection__left .btn').position().top + $('#shop-products').outerHeight() - $('.header').outerHeight() || $('#shop-products').outerHeight() <= $(".st-content").scrollTop() - $('.header').outerHeight() + parseInt($('.shop-filters').height())) {
      $('.collection__top--fixed').css('transition', 'all 0.35s cubic-bezier(0.29, 0.63, 0.44, 1)');
      $('.collection__top--fixed').removeClass('visible');
      $('.shop-filters').css('position', 'absolute');
      $('.shop-filters').css('bottom', '0');
      $('.shop-filters').css('left', '0');
      $('.shop-filters').css('top', 'unset');
    } else if ($(".st-content").scrollTop() >= $('.collection__left .btn').position().top + 10) {
      $('.collection__top--fixed').css('top', $('.header').outerHeight());
      $('.collection__top--fixed').addClass('visible');
      $('.collection__top--fixed').css('transition', 'none');

      $('.shop-filters').css('position', 'fixed');
      $('.shop-filters').css('top', $('.header').outerHeight() + $('.collection__top--fixed').outerHeight());
      $('.shop-filters').css('left', $('.collection__left').offset().left);
      $('.shop-filters').css('max-width', $('.collection__container').width() - $('.collection__container').width() / 100 * 80);
      $('.shop-filters').css('bottom', 'unset');
      $('.shop-filters').css('max-height', $(window).height() - $('.header').outerHeight() - $('.collection__top--fixed').outerHeight());
    } else {
      $('.collection__top--fixed').css('transition', 'none');
      $('.collection__top--fixed').removeClass('visible');
      $('.shop-filters').css('position', 'absolute');
      $('.shop-filters').css('top', 0);
      $('.shop-filters').css('left', 0);
    }
  }

  return {
    init: init,
    recalcFilterSidebar: recalcFilterSidebar
  };
}();

Suit.checkMotivatorBar = function () {
  function init() {
    initCheckMotivatorBar();
  }

  function initCheckMotivatorBar() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if ($(mutation.target).hasClass('mwCMB__text') && $(mutation.target).text().trim()) {
          $('.message').text($(mutation.target).text());
          observer.disconnect();
        }
      });
    });

    var config = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    };

    observer.observe(document.body, config);
  }

  return {
    init: init
  };
}();

Suit.wishlist = function () {
  function init() {
    initWishlist();
    fixWishlist();
  }

  function initWishlist() {
    //Wishlist check
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if ($(mutation.target).is('#bookmarks')) {
          $('header.header').css('cssText', 'z-index: 9999 !important');
          $('#bookmarks .product').each(function () {
            var product = $(this);
            var url = product.find('.image a').attr('href');
            product.find('.image a').addClass('ratio-container');
            product.find('img').addClass('lazyload');
            product.parent().removeClass().addClass('product-container');
            product.find('.addbutton').remove();
            product.find('.buttons').insertAfter(product.find('.text'));
            product.find('.buttons').append('<a href="' + url + '" class="btn seeproduct">See Product</a>');
            product.find('.removebutton').html('x');
          });
        }

        if ($(mutation.target).is('div#smartwishlist')) {
          //$(".product-page__wishlist").remove().clone(true).css("display","block").appendTo(".js-wishlist");
        }
      });
    });

    var config = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    };

    observer.observe(document.body, config);
  }

  function fixWishlist() {

    function transitionEnd() {
      var el = document.createElement('bootstrap');

      var transEndEventNames = {
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd otransitionend',
        transition: 'transitionend'
      };

      for (var name in transEndEventNames) {
        if (el.style[name] !== undefined) {
          return { end: transEndEventNames[name] };
        }
      }

      return false; // explicit for ie8 (  ._.)
    }

    // http://blog.alexmaccaw.com/css-transitions
    $.fn.emulateTransitionEnd = function (duration) {
      var called = false;
      var $el = this;
      $(this).one('bsTransitionEnd', function () {
        called = true;
      });
      var callback = function callback() {
        if (!called) $($el).trigger($.support.transition.end);
      };
      setTimeout(callback, duration);
      return this;
    };

    $(function () {
      $.support.transition = transitionEnd();

      if (!$.support.transition) return;

      $.event.special.bsTransitionEnd = {
        bindType: $.support.transition.end,
        delegateType: $.support.transition.end,
        handle: function handle(e) {
          if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
        }
      };
    });
  }

  return {
    init: init
  };
}();

Suit.newsletter = function () {
  function init() {
    initNewsletter();
  }

  function initNewsletter() {
    $('#mc-embedded-subscribe-form').on('submit', function () {
      var check = true;

      if (!$(this).find('.gender input:checked').length > 0) {
        $(this).find('.gender').append('<div class="mce_inline_error">' + Shopify.trans.newsletterFieldRequired + '</div>');
        check = false;
      }

      return check;
    });
  }

  return {
    init: init
  };
}();

Suit.loginRegister = function () {
  function init() {
    initLoginRegister();
  }

  function initLoginRegister() {
    $('#create_customer').on('submit', function (e) {
      var check = true;
      $('#mc-embedded-subscribe-form-1').find('.mce_inline_error').remove();

      if (!$('#mc-embedded-subscribe-form-1').find('.gender input:checked').length > 0) {
        $('#mc-embedded-subscribe-form-1').find('.gender').append('<div class="mce_inline_error for-gender">' + Shopify.trans.newsletterFieldRequired + '</div>');
        check = false;
      } else {
        $('.mce_inline_error.for-gender').remove();
      }

      if ($(this).parent().find('.privacy:checked').length > 0 && check) {
        var gender = 'gender_' + $('#mc-embedded-subscribe-form-1').find('.gender').find('input[type="radio"]').val().toLowerCase();
        $('#create_customer').append('<input type="hidden" name="customer[tags]" value="' + gender + '"/>');

        if ($('#create_customer').parent().find('.newsletter_section').find('.subscribe-newsletter').is(':checked')) {
          var email = $('#create_customer input[name="customer[email]"]').val();

          $('#mc-embedded-subscribe-form-1').find('input[type="email"]').val(email);
          $('#create_customer').append('<input type="hidden" name="customer[accepts_marketing]" value="true" id="marketing" />');

          $.ajax({
            url: $('#mc-embedded-subscribe-form-1').attr('action'),
            type: 'get',
            data: $('#mc-embedded-subscribe-form-1').serialize(),
            dataType: 'jsonp',
            jsonp: 'c',
            cache: false,
            contentType: 'application/json; charset=utf-8',
            error: function error(err) {
              console.log(err);
            },
            success: function success(data) {
              console.log(data.msg);
            }
          });
        }

        return true;
      } else {
        $(this).parent().find('.privacy+label').addClass('error');
        return false;
      }
    });

    $('.fake-submit').on('click', function (e) {
      $('#create_customer').find('input[type=submit]').trigger('click');

      return true;
    });
  }

  return {
    init: init
  };
}();

Suit.blog = function () {
  function init() {
    initBlog();
  }

  function initBlog() {
    $(window).on('load', function () {
      $('.blog__container').addClass('visible');

      new Masonry('.blog__container', {
        itemSelector: '.blog__image-container',
        columnWidth: '.blog__image-container',
        percentPosition: true
      });
    });
  }

  return {
    init: init
  };
}();

function preventDefaultFunction(event) {
  //console.log(event);
  if (!event.target.matches(".menu-xs *")) {
    event.preventDefault();
    //console.log("BLOCCO");
  } else {
      //console.log("LIBERO");
    }
}
function fix_disableScroll() {
  document.body.addEventListener('touchmove', preventDefaultFunction, { passive: false });
  //console.log("spento scroll");
}
function fix_enableScroll() {
  setTimeout(function () {
    document.body.removeEventListener('touchmove', preventDefaultFunction);
    //console.log("acceso scroll");
  }, 500);
}

//OSERVER
var menu_xs_observer = new MutationObserver(function (mutationRecords) {
  var selector = "div#PageContainer";
  //console.log(mutationRecords);
  //console.log(the changes)
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = mutationRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var record = _step.value;

      if (record.target.matches(selector)) {
        if (record.target.classList.contains('menu-xs-open')) {
          //console.log("APERTO");
          document.querySelector("body").classList.add("menu-xs-open");
          if (document.querySelector("#tidio-chat")) {
            document.querySelector("#tidio-chat").style.display = "none";
            //console.log("tidio via");
          } else {
              //console.log("no tidio");
            }
          fix_disableScroll();
        } else {
          //console.log("CHIUSO");
          document.querySelector("body").classList.remove("menu-xs-open");
          if (document.querySelector("#tidio-chat")) {
            document.querySelector("#tidio-chat").style.display = "initial";
            //console.log("tidio si");
          } else {
              //console.log("no tidio");
            }
          fix_enableScroll();
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
});

menu_xs_observer.observe(document.querySelector("body"), {
  attributes: true,
  //characterData: true,
  childList: true, // observe direct children
  subtree: true, // and lower descendants too
  attributeOldValue: true // pass old data to callback
  //characterDataOldValue: true // pass old data to callback
});

$(document).ready(function () {
  lazySizes.init();
  Suit.init();
});
